import {h, Component} from 'preact';
import authContainer from '../tags/auth-container';
import CloseButtonWithCircle from '../tags/close-button-with-circle';
import ResetPasswordRequest from '../../services/resetPasswordRequest';
import UserAuth from '../../services/userAuth';
import FeatureSettingsService from '../../services/featureSettingsService';
import { SessionStorageKeys } from '../../services/sessionStorageKeys.const';

export class ForgetPassword extends Component {
    constructor() {
        super();
        this.state = {
            pageHeader: 'Password trouble?',
            subTitle: 'Enter your username to look up your account:',
            forgetPasswordEmail: '',
            forgetPasswordError: '',
            requestButton: 'Continue',
            requestButtonLoading: false,
            requestSubmitted: false,
            idpRedirectUrl: null,
            idpMessage: null,
            // helpOnly: false
        }
    }

    componentDidMount() {
        document.title = 'Forget password | workplace_';
        const username = sessionStorage.getItem(SessionStorageKeys.authUsername);
        if (username) {
            this.setState({ forgetPasswordEmail: username });
        }
        this.props.focusById('forget-password-email');
        setTimeout(() => {
            this.props.setFooterClassName('transition-hide');
        });
    }

    onForgetPasswordEmailInput = e => {
        this.setState({
            forgetPasswordEmail: e.target.value,
            forgetPasswordError: '',
            idpRedirectUrl: null,
            idpMessage: null
        });
    };

    setResetPasswordError = (errorObj) => {
        const resetPasswordError = errorObj || {
            pageHeader: 'Your password can’t be reset automatically.',
            subTitle: 'Because your account has extra security features enabled, a human will have to reset your password.',
            requestButton: 'Contact support',
            requestSubmitted: true
        }
        this.setState(resetPasswordError);
    };

    resetPasswordGetLastDigits = () => {
        ResetPasswordRequest.getLastDigits(this.state.forgetPasswordEmail)
            .then(response => {
                this.setState({ requestButtonLoading: false });
                const data = response.data;
                sessionStorage.setItem(SessionStorageKeys.resetPasswordPhoneInfo, JSON.stringify(data));
                sessionStorage.setItem(SessionStorageKeys.authUsername, this.state.forgetPasswordEmail);
                if (data.length && data.length > 0) {
                    if (data[0].reference) {
                        sessionStorage.setItem(SessionStorageKeys.guestAccess, data[0].isGuest);
                        this.props.goToPage('/reset-password');
                    } else {
                        this.setResetPasswordError({
                            pageHeader: 'No mobile number on file',
                            subTitle: 'Because we don’t have your number on file, a human will have to reset your password.',
                            requestButton: 'Contact support',
                            requestSubmitted: true
                        });
                    }
                } else {
                    this.setResetPasswordError();
                }
            }, error => {
                this.setState({ requestButtonLoading: false });
                if (error.response.status === 401) {
                    this.setResetPasswordError();
                }
                if (error.response.status === 404) {
                    this.setState({
                        formErrorNotification: 'No user matches this username.'
                    });
                }
            });
    };

    requestResetPasswordOptions = () => {
        if (!this.state.forgetPasswordEmail) {
            this.setState({ forgetPasswordError: 'Please enter your username.' });
            return false;
        }

        if (this.state.requestButton === 'Contact support') {
            if (!this.props.helpInfo.requestSupportUrl || this.props.helpInfo.requestSupportUrl.includes('/help/support-form')) {
                this.props.goToPage('/help/support-form');
            } else {
                window.location.href = this.props.helpInfo.requestSupportUrl;
            }
            return false;
        }

        if (this.state.requestButtonLoading) {
            console.log('Loading...');
        } else {
            this.setState({ requestButtonLoading: true });
            if (this.state.idpRedirectUrl) {
                window.location.href = this.state.idpRedirectUrl;
            } else {
                //ymakhov. We must reset settings cache for correct displaying of "password reset" page (for Workplace or 3rd party identity provider)
                FeatureSettingsService.init(true).then(() => {
                    if (FeatureSettingsService.isFeatureEnabled('isWebAppSignInPageV2Enabled')) {
                        UserAuth.getIdPData(this.state.forgetPasswordEmail).then(({data}) => {
                            if (data.redirectUrl && data.identityProvider.toLowerCase() !== 'workplace') {
                                this.setState({
                                    requestButtonLoading: false,
                                    idpMessage: 'Your company has Single Sign On enabled. Click “Continue” to sign in to your account.',
                                    idpRedirectUrl: data.redirectUrl
                                });
                            } else {
                                this.resetPasswordGetLastDigits();
                            }
                        }, () => {
                            this.setResetPasswordError();
                        });
                    } else {
                        this.resetPasswordGetLastDigits();
                    }
                });
            }
        }
    };

    submitForm = e => {
        e.preventDefault();
        this.requestResetPasswordOptions();
    };

    goToLoginPage = () => {
        this.props.goToPage('/')
    };

    render({goToPage, helpInfo, renderHelpLink}, {pageHeader, subTitle, forgetPasswordEmail, forgetPasswordError, requestButtonLoading, requestButton, requestSubmitted, idpMessage}) {
        return(
            <section className='auth-modal-container request-access forget-password'>
                <form role='form' onSubmit={this.submitForm}>
                    <div className='form'>
                        <div className='page-header d-flex justify-content-between'>
                            <h2>{pageHeader}</h2>
                            <CloseButtonWithCircle action={this.goToLoginPage}/>
                        </div>
                        <p className='sub-title'>{subTitle}</p>
                        <div className={`form-group clearfix ${requestSubmitted ? 'hidden' : ''}`}>
                            <label htmlFor='forget-password-email'>Username</label>
                            <input className='form-control'
                                   id='forget-password-email'
                                   required
                                   type='text'
                                   value={forgetPasswordEmail}
                                   onInput={this.onForgetPasswordEmailInput}
                            />
                            <p className='idp-message mb-0'>{idpMessage}</p>
                            {forgetPasswordError ? (
                                <div>
                                    <label />
                                    <p><span className='wi wi-warning error-icon'/>{forgetPasswordError}</p>
                                </div>
                            ): null}
                        </div>
                    </div>
                </form>

                <div className='form-submit clearfix'>
                    <p className='other-issues'>
                        {renderHelpLink('pull-left', false)}
                        <a tabIndex='0'
                           className={`button button-prime pull-right ${requestButtonLoading ? 'loading' : ''}`}
                           onClick={this.requestResetPasswordOptions}>{requestButton}</a>
                    </p>
                </div>
            </section>
        )
    }
}

export default authContainer(ForgetPassword);




// WEBPACK FOOTER //
// ./src/scripts/views/reset-password/forget-password.js